var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M909 706L909 734",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 909.5,
    cy: 701.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M904.987 701.19C904.987 697.283 908.288 694.117 912.358 694.117C912.943 694.117 913.511 694.184 914.056 694.308C912.742 693.48 911.187 693 909.519 693C904.814 693 901 696.806 901 701.5C901 706.194 904.814 710 909.519 710C911.814 710 913.895 709.093 915.427 707.62C914.492 708.032 913.454 708.263 912.358 708.263C908.288 708.263 904.987 705.096 904.987 701.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M918.402 700.6L918.37 698.146L916.535 699.719L914.304 699.056L915.112 701.337L913.765 703.381L916.1 703.218L917.499 705.144L918.133 702.763L920.345 701.909L918.402 700.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.ddc12231944df003cf6fcaf6a0e7927c.svg";
export { ForwardRef as ReactComponent };